import { GoLocation } from 'react-icons/go';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  height: 160px;
  position: relative;
  margin-bottom: 24px;
  border-radius: 8px;
  border: 1px solid ${ColorPalette.HEX.BrightGray6};
  overflow: hidden;
`;

export const Button = styled.a`
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 5px 8px;
  font-size: 14px;
  background-color: ${ColorPalette.HEX.White};
  border-radius: 8px;
  cursor: pointer;
  color: ${ColorPalette.HEX.Black};

  & .icons {
    color: ${ColorPalette.HEX.Black};
  }
`;

export const Icon = styled(GoLocation)`
  width: 14px;
  height: 14px;
  font-size: 12px;
  vertical-align: middle;
  margin-right: 3px;
  color: ${ColorPalette.HEX.Black};
`;
